import { useEffect } from "react";
import { usePortalStore } from "../../store/portal/PortalStoreContext";
export function isVerificationExpired(error) {
    const err = error;
    if (err?.response?.data?.requiresVerification === true)
        return true;
    return err?.response?.status === 403;
}
export function useSessionExpiryWatch(errors) {
    const handleSessionExpired = usePortalStore((s) => s.handleSessionExpired);
    const expired = errors.some(isVerificationExpired);
    useEffect(() => {
        if (expired)
            handleSessionExpired();
    }, [expired, handleSessionExpired]);
}
